import { fromJS } from 'immutable';
import * as actions from '../../actions/equityFinder/regression';
import { fetchingState, defaultPageSize } from '../../constants';

const initialStats = {
  regressionAnalysisList: {},
  regressionAnalysisPropertyList: {},
  regressionAnalysisPropertyCompModal: {
    propertyList: {
      pageSize: defaultPageSize,
    },
    selectedProperties: [],
  },
  regressionAnalysisCompPropertyList: {},
};

export default (state = fromJS(initialStats), action) => {
  switch (action.type) {
    case actions.REGRESSION_ANALYSIS_LIST_FETCH_START:
      return state.setIn(
        ['regressionAnalysisList', 'state'],
        fetchingState.FETCHING,
      );
    case actions.REGRESSION_ANALYSIS_LIST_FETCH_SUCCESS:
      let newState = state.setIn(
        ['regressionAnalysisList', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['regressionAnalysisList', 'data'],
        fromJS(action.data && action.data.results ? action.data.results : []),
      );
    case actions.REGRESSION_ANALYSIS_LIST_FETCH_ERROR:
      return state.setIn(
        ['regressionAnalysisList', 'state'],
        fetchingState.ERROR,
      );

    case actions.REGRESSION_ANALYSIS_DELETE_SUCCESS:
      let newRegressionAnalysisList = state
        .getIn(['regressionAnalysisList', 'data'])
        .toJS();
      newRegressionAnalysisList = newRegressionAnalysisList.filter(
        (analysis) => analysis.analysisID !== action.analysisId,
      );
      return state.setIn(
        ['regressionAnalysisList', 'data'],
        fromJS(newRegressionAnalysisList),
      );

    case actions.REGRESSION_ANALYSIS_SET_ACTIVE_SUCCESS:
    case actions.REGRESSION_ANALYSIS_CREATE_SUCCESS:
      return state.setIn(
        ['regressionAnalysisList', 'data'],
        fromJS(action.data.results),
      );

    case actions.REGRESSION_ANALYSIS_PROPERTY_LIST_FETCH_START:
      return state.setIn(
        ['regressionAnalysisPropertyList', 'state'],
        fetchingState.FETCHING,
      );
    case actions.REGRESSION_ANALYSIS_PROPERTY_LIST_FETCH_SUCCESS:
      newState = state.setIn(
        ['regressionAnalysisPropertyList', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['regressionAnalysisPropertyList', 'data', action.analysisId],
        fromJS(action.data && action.data.results ? action.data.results : []),
      );
    case actions.REGRESSION_ANALYSIS_PROPERTY_LIST_FETCH_ERROR:
      return state.setIn(
        ['regressionAnalysisPropertyList', 'state'],
        fetchingState.ERROR,
      );

    case actions.REGRESSION_ANALYSIS_PROPERTY_DELETE_SUCCESS:
      newRegressionAnalysisList = state
        .getIn(['regressionAnalysisList', 'data'])
        .toJS();
      newRegressionAnalysisList = newRegressionAnalysisList.map((value) => {
        const newValue = value;
        if (newValue.analysisID === action.analysisId) {
          newValue.compCount--;
        }
        return newValue;
      });
      let regressionAnalysisPropertyList = state
        .getIn(['regressionAnalysisPropertyList', 'data', action.analysisId])
        .toJS();
      regressionAnalysisPropertyList = regressionAnalysisPropertyList.filter(
        (analysis) => analysis.compID !== action.compId,
      );
      newState = state.setIn(
        ['regressionAnalysisList', 'data'],
        fromJS(newRegressionAnalysisList),
      );
      return newState.setIn(
        ['regressionAnalysisPropertyList', 'data', action.analysisId],
        fromJS(regressionAnalysisPropertyList),
      );

    case actions.REGRESSION_ANALYSIS_COMP_PROPERTY_LIST_FETCH_START:
      return state.setIn(
        ['regressionAnalysisPropertyCompModal', 'propertyList', 'state'],
        fetchingState.FETCHING,
      );
    case actions.REGRESSION_ANALYSIS_COMP_PROPERTY_LIST_FETCH_SUCCESS:
      newState = state.setIn(
        ['regressionAnalysisPropertyCompModal', 'propertyList', 'state'],
        fetchingState.LOADED,
      );
      newState = newState.setIn(
        ['regressionAnalysisPropertyCompModal', 'propertyList', 'totalCount'],
        action?.data?.totalProperty ? action.data.totalProperty.propCount : 0,
      );
      newState = newState.setIn(
        ['regressionAnalysisPropertyCompModal', 'propertyList', 'categoryName'],
        action.data.categoryName,
      );
      newState = newState.setIn(
        [
          'regressionAnalysisPropertyCompModal',
          'propertyList',
          'propertyCategory',
        ],
        action.data.propertyCategory,
      );
      return newState.setIn(
        ['regressionAnalysisPropertyCompModal', 'propertyList', 'data'],
        fromJS(action.data.results),
      );
    case actions.REGRESSION_ANALYSIS_COMP_PROPERTY_LIST_FETCH_ERROR:
      return state.setIn(
        ['regressionAnalysisPropertyCompModal', 'propertyList', 'state'],
        fetchingState.ERROR,
      );

    case actions.REGRESSION_ANALYSIS_PROPERTY_COMP_SEARCH_START:
      return state.setIn(
        ['regressionAnalysisCompPropertyList', 'state'],
        fetchingState.FETCHING,
      );
    case actions.REGRESSION_ANALYSIS_PROPERTY_COMP_SEARCH_SUCCESS:
      newState = state.setIn(
        ['regressionAnalysisCompPropertyList', 'state'],
        fetchingState.LOADED,
      );
      newState = newState.setIn(
        ['regressionAnalysisCompPropertyList', 'totalCount'],
        action?.data?.totalProperty ? action.data.totalProperty.propCount : 0,
      );
      newState = newState.setIn(
        ['regressionAnalysisCompPropertyList', 'category'],
        fromJS(action.data.category),
      );
      newState = newState.setIn(
        ['regressionAnalysisCompPropertyList', 'stats'],
        fromJS(action.data.stats),
      );
      return newState.setIn(
        ['regressionAnalysisCompPropertyList', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case actions.REGRESSION_ANALYSIS_PROPERTY_COMP_SEARCH_ERROR:
      return state.setIn(
        ['regressionAnalysisCompPropertyList', 'state'],
        fetchingState.ERROR,
      );

    case actions.REGRESSION_ANALYSIS_COMP_ADD_SUCCESS:
      newRegressionAnalysisList = state
        .getIn(['regressionAnalysisList', 'data'])
        .toJS();
      newRegressionAnalysisList = newRegressionAnalysisList.map((value) => {
        const newValue = value;
        if (newValue.analysisID === action.analysisId) {
          newValue.compCount = action.data.results.length;
        }
        return newValue;
      });
      newState = state.setIn(
        ['regressionAnalysisList', 'data'],
        fromJS(newRegressionAnalysisList),
      );
      return newState.setIn(
        ['regressionAnalysisPropertyList', 'data', action.analysisId],
        fromJS(action.data ? action.data.results : []),
      );

    case actions.REGRESSION_ANALYSIS_PROPERTY_COMP_SELECT_PROPERTY:
      return state.setIn(
        ['regressionAnalysisPropertyCompModal', 'selectedProperties'],
        action.data,
      );
    case actions.REGRESSION_ANALYSIS_PROPERTY_COMP_PROPERTY_CHANGE_CURRENT_PAGE:
      return state.setIn(
        ['regressionAnalysisPropertyCompModal', 'propertyList', 'currentPage'],
        action.data,
      );
    case actions.REGRESSION_ANALYSIS_PROPERTY_COMP_PROPERTY_CHANGE_PAGE_SIZE:
      return state.setIn(
        ['regressionAnalysisPropertyCompModal', 'propertyList', 'pageSize'],
        action.data,
      );
    default:
      return state;
  }
};
